import { h, Component } from 'preact';
import PropTypes from 'prop-types';

// Components
import { checkConditions } from '../../../../utilities/package/packageUtils';
import {
  getCoverageCodesAndMergeCodes,
  replaceData,
} from '../../../../utilities/common';
import { stepShowHide } from '../../../../utilities/form/formUtils';

import SelectorItem from './SelectorItem';
import Label from '../../../Form/Label';
import Space from '../Space';
import Text from '../../../Global/Text';

class Packages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selecetedPackage: '',
    };
    this.renderSelectorItems = this.renderSelectorItems.bind(this);
    this.selectorClick = this.selectorClick.bind(this);
  }

  componentDidMount() {
    const { productBoxes, userData } = this.props;
    productBoxes.forEach((item) => {
      const isRecommended =
        item.recommended && checkConditions(item.recommended, userData);
      if (isRecommended) {
        this.setState({ selecetedPackage: item.title });
      }
    });
  }
  selectorClick(value) {
    this.setState({ selecetedPackage: value });
  }

  renderSelectorItems(sort) {
    const {
      userData,
      values,
      initialValues,
      actions,
      dispatch,
      label,
      coverageText,
      recommendedText,
      selectedPackageText,
      advancedCoverage,
      setValues,
      toolTip,
      campaignHeaderLabelText,
      packagePriceText,
      buttonTextMobile,
    } = this.props;

    let { productBoxes } = this.props;
    const { selecetedPackage } = this.state;
    const { packages, coverageMerge } = initialValues;

    if (sort) {
      productBoxes = [...productBoxes].sort((p1, p2) => {
        let isRecommended =
          p1.recommended && checkConditions(p1.recommended, userData);
        if (isRecommended) {
          return -1;
        }

        isRecommended =
          p2.recommended && checkConditions(p2.recommended, userData);
        if (isRecommended) {
          return 1;
        }

        return 0;
      });
    }

    return productBoxes.map((productSelector) => {
      const { recommended, packageId, coverages } = productSelector;
      const packageItem = packages.reduce((ag, element) => {
        return element.id === packageId ? element : ag;
      }, {});
      const [coverageCodes, coverageCodesMerge] = getCoverageCodesAndMergeCodes(
        coverages &&
          coverages.split('.').reduce((obj, index) => obj[index], userData),
        coverageMerge,
        userData,
        packageItem
      );

      const campaign =
        initialValues.campaign &&
        (!initialValues.campaign.showForPackages ||
          initialValues.campaign.showForPackages.includes(packageId))
          ? initialValues.campaign.productSelector || {}
          : {};

      const column = 12 / productBoxes.length;
      const isRecommended =
        recommended && checkConditions(recommended, userData);
      const priceUnitLabel = replaceData(label, userData);
      const unit =
        Object.hasOwnProperty.call(initialValues, 'units') &&
        Object.hasOwnProperty.call(userData, priceUnitLabel)
          ? initialValues.units[userData[priceUnitLabel]]
          : priceUnitLabel;

      const showPrePrice =
        campaign.showPrePrice || productSelector.showPrePrice;

      if (advancedCoverage) {
        // Set form params for each coverage code.
        if (!values.coverageCodes) {
          values.coverageCodes = [
            ...coverages
              .split('.')
              .reduce((obj, index) => obj[index], userData),
          ];
          values.coverageCodes.forEach((coverageCode) => {
            values[coverageCode] = true;
          });
          setValues({ ...values });
        }
      }

      if (
        productSelector.showHide &&
        stepShowHide(false, productSelector.showHide, userData, values)
      ) {
        return <div />;
      }

      const productSelectorItemDetails = {
        recommendedText,
        selectedPackageText,
        isRecommended,
        coverageText,
        packageItem,
        coverageCodes,
        coverageCodesMerge,
        advancedCoverage,
        actions,
        dispatch,
        label,
        column,
        toolTip,
        campaignHeaderLabelText,
        packagePriceText,
        productSelector: { ...productSelector, showPrePrice },
        initialValues,
        userData,
        campaign,
        values,
        unit,
        buttonTextMobile,
      };
      return (<SelectorItem
        {...productSelectorItemDetails}
        selectedItem={selecetedPackage}
      />);
    });
  }

  render() {
    const {
      productFooterNote,
      labelActions,
      dispatch,
      values,
      setValues,
      productBoxes,
    } = this.props;

    const { selecetedPackage } = this.state;

    const screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    const list = productBoxes.map((item) => {
      /* eslint-disable-next-line */
      return(<li key={item.title} className={item.title === selecetedPackage ? 'active' : ''} onClick={() => this.selectorClick(item.title)}>{item.title}</li>)
    });

    return (
      <div>
        <ul
          key={selecetedPackage}
          className="product-selector-tab-v3"
        >
          {list}
        </ul>
        <div className='grid align-center align-items-flex-end'>
          {this.renderSelectorItems()}
        </div>
        <div className='productbox__footernote  grid__col grid__col--12 grid__col--md-12'>
          <Label
            id='advancedProductFooterNote'
            label={productFooterNote}
            className='label__action'
            actions={labelActions}
            dispatch={dispatch}
            values={values}
            setValues={setValues}
          />
          {this.props.groupAdvantageBlock &&
            <div>
              <Space rows="5"/>
              <div className="text--greyBox">
                <Text value={this.props.groupAdvantageBody} />
                <Label
                  id="groupAdvantageModal"
                  label={this.props.groupAdvantageModalLabel}
                  className="label__action"
                  actions={this.props.groupAdvantageModalActions}
                  dispatch={this.props.dispatch}
                  values={this.props.values}
                  setValues={this.props.setValues}
                />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default Packages;

Packages.defaultProps = {
  actions: [],
  advancedCoverage: false,
  defaultSelected: '',
  groupAdvantageBlock: false,
  groupAdvantageBody: '',
  groupAdvantageModalLabel: '',
  groupAdvantageModalActions: [],
  campaignHeaderLabelText: 'Din onlinerabat',
  packagePriceText: 'Pris',
};

Packages.propTypes = {
  productFooterNote: PropTypes.string.isRequired,
  buttonTextMobile: PropTypes.string.isRequired,
  recommendedText: PropTypes.string.isRequired,
  selectedPackageText: PropTypes.string.isRequired,
  initialValues: PropTypes.object.isRequired,
  coverageText: PropTypes.string.isRequired,
  productBoxes: PropTypes.array.isRequired,
  labelActions: PropTypes.array.isRequired,
  userData: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  toolTip: PropTypes.string.isRequired,
  campaignHeaderLabelText: PropTypes.string,
  packagePriceText: PropTypes.string,
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  advancedCoverage: PropTypes.bool,
  actions: PropTypes.array,
  defaultSelected: PropTypes.string,
  groupAdvantageBody: PropTypes.string,
  groupAdvantageModalLabel: PropTypes.string,
  groupAdvantageBlock: PropTypes.bool,
  groupAdvantageModalActions: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/Steps/General/ProductSelector/Packages.jsx